import SignIn from 'components/auth/SignIn';
import useInput from 'lib/hooks/useInput';
import React, { useContext, useEffect, useMemo } from 'react';
import {
  AppActions,
  AuthActions,
  UserActions,
  BaseActions,
  EmployeeActions,
} from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';
import { AppContext } from 'contexts/AppContext';
import { useDidUpdateEffect } from 'lib/utils';
import { useHistory } from 'react-router-dom';
import { pageUrl } from 'lib/mapper';
import { loginUserHistory, signInUser } from 'store/modules/auth';
import { encodedByAES56 } from 'lib/utils';

export default function SignInContainer() {
  const {
    user,
    signInByEmployeeData,
    signInByEmployeeSuccess,
    language,
    fetchProfileSuccess,
  }: // isLogIn,
  {
    user: any;
    signInByEmployeeData: { accessToken: string };
    signInByEmployeeSuccess: boolean;
    language: string;
    fetchProfileSuccess: boolean;
  } = useShallowAppSelector(state => ({
    user: state.user.user,
    signInByEmployeeData: state.employee.signInByEmployee.data,
    signInByEmployeeSuccess: state.employee.signInByEmployee.success,
    language: state.base.language,
    // isLogIn: isLogInSelector(state),
    fetchProfileSuccess: state.user.fetchProfile.success,
  }));

  const history = useHistory();
  // 필수값
  const { nickname: nicknameState, email: emailState } = history.location.state || {
    nickname: '',
    email: '',
  };
  const nickname = useInput(nicknameState);
  const email = useInput(emailState);
  const password = useInput('');
  const { signInCode, setSignInCode } = useContext(AppContext);
  // eslint-disable-next-line
  const setNickNameValue = useMemo(() => {
    return signInCode && nickname.setValue(signInCode);
  }, [signInCode]);

  const isValidForm = useMemo(() => {
    console.log('email.value', email.value);
    return nickname.value?.trim() && email.value?.trim() && password.value?.trim();
  }, [nickname.value, email.value, password.value]);

  // SECTION: function

  const handleChangeLanguage = () => {
    let languageType = '';
    if (language === 'ko') languageType = 'en';
    if (language === 'en') languageType = 'ko';
    BaseActions.change_language(languageType);
  };

  const handleSubmit = () => {
    if (!isValidForm) return;

    const submitData = {
      nickname: nickname.value,
      email: email.value,
      password: encodedByAES56(password.value, 1),
      // autoLogin: autoLogin.value,
    };
    // console.log('submitData ******* ', submitData, 1);

    // console.log(submitData, 'submitData');
    EmployeeActions.sign_in_by_employee_request({
      nickname: nickname.value?.trim(),
      email: email.value?.trim(),
      password: encodedByAES56(password.value?.trim(), 1),
      // password: 'ZYbA$TxWp6',
    });
  };

  // SECTION: DidUpdate

  useDidUpdateEffect(() => {
    if (signInByEmployeeSuccess) {
      console.log('signInByEmployeeSuccess _____');
      signInUser(signInByEmployeeData.accessToken, email.value?.trim());
      loginUserHistory(email.value?.trim(), nickname.value?.trim());
      // AppActions.set_dim(true);
      // // history.push(pageUrl.home);
      // history.push(pageUrl.dashboard.index);
      UserActions.fetch_profile_request();
    }
  }, [!!signInByEmployeeSuccess]);

  useDidUpdateEffect(() => {
    if (fetchProfileSuccess) {
      // console.log('useruseruseruseruser____ ', user);
      // history.push(pageUrl.home);
      history.push(pageUrl.dashboard.index);
    }
  }, [fetchProfileSuccess]);

  return (
    <SignIn
      isValidForm={isValidForm}
      nickname={nickname}
      email={email}
      password={password}
      onSubmit={handleSubmit}
      onChangeLanguage={handleChangeLanguage}
    />
  );
}
